<template>
  <Transition name="fcom_card-fade">
    <div
      v-if="visible && event"
      :class="['fcom_event_card', { 'is-positioned': position }]"
      :style="cardStyle"
      role="dialog"
      aria-modal="false"
      :aria-label="__('event_details')"
      @click.stop="$emit('view')"
    >
      <!-- Image / placeholder -->
      <div class="fcom_event_card-image">
        <img v-if="event.image" :src="event.image" :alt="event.title" />
        <div v-else class="fcom_event_card-image-placeholder">
          <i class="fcom_icon" v-html="icons.calendarFilled" />
        </div>
        <div v-if="event.date_local" class="fcom_event_card-date-badge">
          <span class="fcom_event_card-date-month">{{ monthAbbr(event.date_local) }}</span>
          <span class="fcom_event_card-date-day">{{ parseInt(event.date_local.slice(8, 10)) }}</span>
        </div>
      </div>

      <!-- Body -->
      <div class="fcom_event_card-body">
        <div class="fcom_event_card-type-row">
          <span v-if="event.status === 'draft'" class="fcom_event_card-draft-badge">{{ __('draft') }}</span>
          <span v-if="event.categories?.length" class="fcom_event_card-type-badge">{{ event.categories[0].name }}</span>
        </div>

        <h4 class="fcom_event_card-title">{{ event.title }}</h4>

        <div class="fcom_event_card-meta">
          <div v-if="event.date_display_mid || event.date_display" class="fcom_event_card-meta-row">
            <i class="fcom_icon" v-html="icons.calendarFilled" aria-hidden="true" />
            <span>{{ event.date_display_mid || event.date_display }}</span>
          </div>
          <div v-if="event.time_display" class="fcom_event_card-meta-row">
            <i class="fcom_icon" v-html="icons.clockFilled" aria-hidden="true" />
            <span>{{ event.time_display }}</span>
          </div>
          <div v-if="event.location || event.is_online" class="fcom_event_card-meta-row">
            <i class="fcom_icon" v-html="event.is_online ? icons.monitorFilled : icons.locationFilled" aria-hidden="true" />
            <span>{{ event.is_online ? __('online') : event.location }}</span>
          </div>
        </div>

        <p v-if="event.summary" class="fcom_event_card-summary">{{ event.summary }}</p>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from 'vue'
import { DateTime } from 'luxon'
import { __ } from '@/utils/i18n.js'
import icons from '@/utils/icons.js'

const props = defineProps({
  event:    { type: Object,  default: null },
  visible:  { type: Boolean, default: false },
  position: { type: Object,  default: null },
})

defineEmits(['view'])

function monthAbbr(dateStr) {
  if (!dateStr) return ''
  return DateTime.fromISO(dateStr).toFormat('MMM')
}

const cardStyle = computed(() => {
  if (!props.position) return {}
  const style = {
    position: 'fixed',
    top: `${props.position.y}px`,
    zIndex: 1000,
  }
  if (props.position.placement === 'left') {
    style.right = `${window.innerWidth - props.position.x}px`
  } else {
    style.left = `${props.position.x}px`
  }
  return style
})
</script>
